





































import { Component, Prop, Vue } from 'vue-property-decorator';
import { TForm } from '@/plugins/podolib/lib/types';
import { ValidationProvider } from 'vee-validate/dist/types/components/Provider';

@Component
export default class AuthCard extends Vue {
  @Prop({ required: true }) form!: TForm<any>;
  @Prop({ required: true }) titleText!: string;
  @Prop({ required: true }) subtitleText!: string;
  @Prop({ required: true }) actionText!: string;

  $refs!: {
    observer: InstanceType<typeof ValidationProvider>;
  };

  submit() {
    this.$emit('submit');
  }
}
